let styles = {
    container: {
        background: 'white',
        padding: '2%',
        display: 'flex',
        justifyContent: 'center',
    },
    main_header: {
        padding:'0px',
        margin:'10px 0px',
        display:'flex',
        background: '#7d3cff',
    },
    title: {
        padding:'5px',
        textAlign:'center',
        borderRadius:'0px'
    },
    row: {
        margin:'1% 0%',
        fontSize:'15px',
        fontWeight:'600'
    },
    table_header: {
        marginTop:'1%',
        padding:10,
        display:"flex",
        fontWeight:'600',
        color:'black'
    },
    table: {
        marginTop:'2%'
    },
    header: {
        marginBottom:'2%'
    },
    date: {
        display: 'flex',
        padding: 0,
        marginBottom:'2%',
    },
    am_sport_container: {
        display: 'flex',
        overflowX: 'auto',
        padding: '10px',
        gap: '10px',
        scrollbarWidth: 'thin',
        background: '#f9f9f9',
        borderRadius: '22px',
        border: '1px solid #E1EBFF',
        marginBottom: '1%',
    },
    am_sport_card: {
        borderRadius: '12px',
        padding: '24px',
        backgroundColor: '#f0f5fa',
        border: '1px solid #E1EBFF',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        width: '300px',
        transition: 'transform 0.25s ease',
    },
    card_title: {
        fontSize: '18px',
        fontWeight: '600',
        marginBottom: '10px',
        color: '#333',
    },
    card_value: {
        fontSize: '16px',
        color: '#2e7d32',
    },

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/collectionList/style.js